import React, { createContext, useEffect, useState } from "react";
import { getApiBaseUrl } from "../config";
import LoadingPage from "../Components/LoadingPage/LoadingPage";

export const ShopContext = createContext(null);



const getDefaultCart = () => {
    const savedCart = localStorage.getItem('guestCart');
    return savedCart ? JSON.parse(savedCart) : {}; // Initialize with an empty object
};

const ShopContextProvider = (props) => {
    const [all_product, setAll_Product] = useState([]); // Holds all product data
    const [cartItems, setCartItems] = useState(getDefaultCart());
    const [loading, setLoading] = useState(true); // To manage loading state
    const [error, setError] = useState(null); // For error handling

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                console.log("Fetching all products...");
                const response = await fetch(`${getApiBaseUrl()}/allproducts`, {
                    method: "GET",
                    credentials: "include",
                });
                if (!response.ok) throw new Error("Failed to fetch products");
                const data = await response.json();
                data.forEach(product => {
                    console.log(`Product ID: ${product._id}, Images:`, product.images);
                });
                setAll_Product(data);
            } catch (err) {
                console.error("Error fetching products:", err);
                setError("Failed to fetch products.");
            }
        };
        fetchProducts();
    }, []);
    

    // Fetch the cart from the backend when the component mounts
    useEffect(() => {
        const fetchCartData = async () => {
            console.log("Fetching cart data...");
            try {
                const token = localStorage.getItem("auth-token");
                console.log("Token from localStorage:", token);
    
                if (token) {
                    const response = await fetch(`${getApiBaseUrl()}/getcart`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'auth-token': token, // Send the token in the request header
                        },
                    });
                    
    
                    const data = await response.json();
                    console.log("Cart data response:", data);
    
                    if (data.success) {
                        console.log("Successfully fetched from cart api");
                        const fetchedCart = data.cartData.reduce((cart, item) => {
                            const key = `${String(item.productId)}-${item.size}-${item.color}`;  // Ensure productId is a string
                            cart[key] = {
                                quantity: item.quantity,
                                size: item.size,
                                color: item.color,
                            };
                            return cart;
                        }, {});
    
                        console.log("Fetched cart:", fetchedCart);
                        setCartItems(fetchedCart);
                    } else {
                        console.error('Error fetching cart data:', data.errors);
                    }
                } else {
                    console.log("No auth-token found.");
                }
            } catch (error) {
                console.error('Error fetching cart:', error);
                setError('Failed to load cart data.');
            } finally {
                setLoading(false);
            }
        };
    
        fetchCartData(); // Call the function when the component mounts
    }, []); // Empty dependency array ensures this runs once when the component mounts
    
// Function that updates the stock after purchase
const updateStock = async (cartItems) => {
    try {
        const response = await fetch(`${getApiBaseUrl()}/updatestock`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ cartItems }),
        });

        if (!response.ok) throw new Error('Failed to update stock');

        console.log("Stock updated successfully");
    } catch (error) {
        console.error("Error updating stock:", error);
    }
};

    
    const addToCart = async (itemId, quantity, size, color) => {
        console.log("Attempting to add to cart:", { itemId, quantity, size, color });
    
        if (!itemId || !size || !color || !quantity) {
            console.error("Invalid parameters: Missing itemId, size, color, or quantity.");
            return;
        }
    
        const key = `${itemId}-${size}-${color}`;
    
        // Update UI Optimistically
        setCartItems((prev) => ({
            ...prev,
            [key]: prev[key]
                ? { ...prev[key], quantity: prev[key].quantity + quantity }
                : { quantity, size, color },
        }));
    

        // Sync cart with the server if authenticated
        if (localStorage.getItem('auth-token')) {
            console.log("Sending add-to-cart request to server...");
            try {
                const response = await fetch(`${getApiBaseUrl()}/addtocart`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'auth-token': `${localStorage.getItem('auth-token')}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ itemId, quantity, size, color }),
                });
    
                const data = await response.json();
                console.log("Response data from add-to-cart:", data);
    
                if (data.success) {
                    // Fetch updated cart from the server to ensure UI updates
                    fetchCartData();
                } else {
                    console.error("Error adding item to cart:", data.message);
                }
            } catch (err) {
                console.error("Error in addToCart fetch:", err);
            }
        } else {
            console.log("No auth-token found, cart data not synced with server.");
        }
    };
    
    // Function to fetch cart data (make sure it's accessible)
    const fetchCartData = async () => {
        console.log("Fetching cart data...");
        try {
            const token = localStorage.getItem("auth-token");
            if (!token) {
                console.log("No auth-token found.");
                return;
            }
    
            const response = await fetch(`${getApiBaseUrl()}/getcart`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token, // Send the token in the request header
                },
                credentials: 'include', // Include cookies (useful if backend uses cookie-based authentication)
            });
            
    
            const data = await response.json();
            console.log("Cart data response:", data);
    
            if (data.success) {
                const fetchedCart = data.cartData.reduce((cart, item) => {
                    const key = `${String(item.productId)}-${item.size}-${item.color}`;
                    cart[key] = { quantity: item.quantity, size: item.size, color: item.color };
                    return cart;
                }, {});
    
                console.log("Fetched cart:", fetchedCart);
                setCartItems(fetchedCart);
            } else {
                console.error('Error fetching cart data:', data.errors);
            }
        } catch (error) {
            console.error('Error fetching cart:', error);
            setError('Failed to load cart data.');
        }
    };
    


// Remove item from cart with updated quantity
const removeFromCart = async (itemId, size, color, quantity) => {
    try {
        console.log("Removing item from cart:", { itemId, size, color, quantity });

        // Send request to backend to update cart
        const token = localStorage.getItem('auth-token');
        if (!token) {
            console.error("No auth token found, unable to remove item.");
            return;
        }

        const response = await fetch(`${getApiBaseUrl()}/removeFromCart`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': token, // Send the token in the request header
            },
            body: JSON.stringify({ itemId, size, color, quantity }),
        });

        const data = await response.json();
        if (!data.success) {
            console.error("Error removing item from cart:", data.errors);
            return;
        }

        // Update the cart state on success
        setCartItems((prev) => {
            const updatedCart = { ...prev };
            const key = `${itemId}-${size}-${color}`;

            // If quantity is greater than what was requested, decrease the quantity
            if (updatedCart[key]) {
                if (updatedCart[key].quantity > quantity) {
                    updatedCart[key].quantity -= quantity;
                } else {
                    // If quantity is less than or equal to the requested quantity, remove the item
                    delete updatedCart[key];
                }
            }
            return updatedCart;
        });

        console.log("Item removed from cart successfully");
    } catch (error) {
        console.error("Error removing item from cart:", error);
    }
};



const clearCart = async () => {
    try {
        console.log("Clearing cart...");

        const token = localStorage.getItem("auth-token");
        if (!token) {
            console.error("No auth token found, unable to clear cart.");
            return;
        }

        // Send the request to clear the cart
        const response = await fetch(`${getApiBaseUrl()}/clearcart`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': token, // Send the token in the request header
            },
        });

        const data = await response.json();

        if (data.success) {
            // Optimistically update the cart to be empty
            setCartItems({});
            console.log("Cart cleared successfully");
        } else {
            console.error("Error clearing cart:", data.errors);
        }
    } catch (error) {
        console.error("Error clearing cart:", error);
    }
};


    // Update cart item quantity
    const updateCartItemQuantity = (itemId, size, color, quantity) => {
        const key = `${itemId}-${size}-${color}`;
        console.log("Updating cart item quantity:", { itemId, size, color, quantity });

        setCartItems((prev) => ({
            ...prev,
            [key]: { quantity, size, color },
        }));
    };

    // Get total cart amount
    const getTotalCartAmount = () => {
        if (!all_product || all_product.length === 0) {
            console.log("Products not loaded yet.");
            return 0; // or return a default value
        }
    
        let totalAmount = 0;
        console.log("Calculating total cart amount...");
        for (const key in cartItems) {
            if (cartItems[key].quantity > 0) {
                const [itemId] = key.split('-');
                const itemInfo = all_product.find((product) => product._id === itemId);
                const price = itemInfo ? itemInfo.new_price : 0;
                totalAmount += price * cartItems[key].quantity;
            }
        }
        console.log("Total cart amount:", totalAmount);
        return totalAmount;
    };
    

    // Get total items in cart
    const getTotalCartItems = () => {
        let totalItem = 0;
        console.log("Calculating total cart items...");
        for (const key in cartItems) {
            if (cartItems[key].quantity > 0) {
                totalItem += cartItems[key].quantity;
            }
        }
        console.log("Total cart items:", totalItem);
        return totalItem;
    };


    const mergeCart = async () => {
        try {
            const token = localStorage.getItem("auth-token");
            
            // If no token is found, no need to merge. Just use the guest cart
            if (!token) {
                console.log("No auth-token found, using guest cart.");
                return;
            }
    
            // Prepare the guest cart from localStorage
            const guestCart = JSON.parse(localStorage.getItem('guestCart')) || {};
            console.log("Guest Cart Data:", guestCart);

            // Check if guestCart is an object with a cartData array
            if (!guestCart.cartData || !Array.isArray(guestCart.cartData)) {
                console.error("guestCart.cartData is not an array:", guestCart.cartData);
                return;  // Exit if guestCart.cartData is not an array
            }
    
            // Fetch current cart from the backend (for logged-in user)
            const response = await fetch(`${getApiBaseUrl()}/getcart`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token, // Send the token in the request header
                },
            });
    
            const data = await response.json();
            console.log("Fetched cart data from server:", data);
    
            if (data.success) {
                // Merge the guest cart with the user cart from the backend
                const userCart = data.cartData;
    
                // Merge guest cart with the logged-in user cart
                const mergedCart = [...userCart, ...guestCart.cartData];
    
                // Remove duplicates by combining quantities of the same product
                const mergedCartWithoutDuplicates = mergedCart.reduce((acc, item) => {
                    const key = `${item.productId}-${item.size}-${item.color}`;
    
                    if (acc[key]) {
                        acc[key].quantity += item.quantity; // Merge quantity
                    } else {
                        acc[key] = { ...item };
                    }
    
                    return acc;
                }, {});
    
                // Convert merged cart to an array of items
                const mergedCartArray = Object.values(mergedCartWithoutDuplicates);
    
                // Send the merged cart back to the server to save it
                const mergeResponse = await fetch(`${getApiBaseUrl()}/mergecart`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': token,
                    },
                    body: JSON.stringify({ cartData: mergedCartArray }),
                });
    
                const mergeData = await mergeResponse.json();
                console.log("Merge cart response:", mergeData);
    
                if (mergeData.success) {
                    // Update the state with the merged cart
                    setCartItems(mergedCartWithoutDuplicates);
                    // Optionally, clear guest cart after successful merge
                    localStorage.removeItem('guestCart');
                    console.log("Cart merged successfully!");
                } else {
                    console.error("Failed to merge cart:", mergeData.message);
                }
            } else {
                console.error("Error fetching user cart:", data.message);
            }
        } catch (error) {
            console.error("Error during cart merge:", error);
        }
    };
    

    

    const contextValue = {
        user: {
            cartData: cartItems,
            all_product,
        },
        getTotalCartItems,
        getTotalCartAmount,
        all_product,
        cartItems,
        addToCart,
        removeFromCart,
        clearCart,
        mergeCart,
        updateCartItemQuantity,
        updateStock,
    };

    if (loading) {
        return <LoadingPage />
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <ShopContext.Provider value={contextValue}>
            {props.children}
        </ShopContext.Provider>
    );
};

export default ShopContextProvider;
